import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "bonuses",
    name: "Bonuses",
    version: "0.1.0",
    tier: "addon",
    accent: "promotions",
    dependsOn: ["sites", "budgets"],
    description: "Bonus ladders on targets: hit X% of a target (sales, a department, fuel litres, waste…) and earn £Y, paid automatically on the operator's commission or fee invoice, with live progress.",
    permissions: {
        view: "See bonus schemes and progress for your sites",
        manage: "Create and change bonus schemes (head office)",
    },
    grants: { "Head office": ["view", "manage"], "Area manager": ["view"], "Site manager": ["view"], Supervisor: ["view"] },
    nav: [
        // Four areas under the Bonuses tab (29/10/26, Jamie: "a sub-menu instead of all the stuff it has now").
        { label: "Overview", path: "/bonuses", section: "reports", tab: "Bonuses", tabIcon: "target", permission: "view", icon: "target", order: 62, blurb: "This period at a glance: earned so far, on track, behind, Lynked days" },
        { label: "Schemes", path: "/bonuses/schemes", section: "reports", tab: "Bonuses", tabIcon: "target", permission: "manage", icon: "layers", order: 62.1, blurb: "Each bonus scheme: what it's judged on, the reward and the sites" },
        { label: "Set targets", path: "/bonuses/targets", section: "reports", tab: "Bonuses", tabIcon: "target", permission: "manage", icon: "sliders", order: 62.2, blurb: "Targets per site for each period, caps on GP points" },
        { label: "Results", path: "/bonuses/results", section: "reports", tab: "Bonuses", tabIcon: "target", permission: "view", icon: "award", order: 62.3, blurb: "Each period's results per site, what's paid and off the rent" },
    ],
});
